import { Authorization } from 'components/auth/model-authorization'
import { TipoEstabelecimentoEnum } from 'graphql/types.generated'

export const SOLICITACAO_EXAMES_PROCEDIMENTOS_TAB_NAME = 'Solicitação de exames/procedimentos'

export enum PlanoTabsEnum {
  PRESCRICAO_MEDICAMENTOS,
  ATESTADO,
  EXAMES,
  ENCAMINHAMENTO_EXTERNO,
  DECLARACAO_COMPARECIMENTO,
  ORIENTACOES,
  CUIDADO_COMPARTILHADO,
}

export interface PlanoTabConfig {
  enum: PlanoTabsEnum
  label: string
  testId: string
  permissions: {
    permission: Authorization
    tiposEstabelecimento?: TipoEstabelecimentoEnum[]
    acceptEstagio?: boolean
  }
  showItem: boolean
}
